(($, Drupal) => {
  Drupal.behaviors.banner = {
    attach: function attach() {
      $('.banner__slider').once('add').each(function (index) {
        const swiper = new Swiper(this, {
          autoHeight: true,
          autoplay: {
            delay: 5000,
          },
          loop: true,
          pagination: {
            el: '.swiper-banner-pagination',
            bulletClass: 'swiper-banner-pagination-bullet',
            bulletActiveClass: 'swiper-banner-pagination-bullet--active',
            clickable: true,
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
        });
      });
    },
  };
})(jQuery, Drupal);
